export default __webpack_public_path__ + "static/media/noteIcon.e95601bf.svg";